/**
 * Список статей форм декларацій (Підпорція 3.2b, 2026-05-25).
 *
 * Global ref: 35 записів seed (22 VAT + 13 PROFIT).
 * Фільтр по form_type.
 */
import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  taxDeclarationArticles,
  type TaxDeclarationArticle,
  type TaxFormType,
} from '@/api/taxDeclarationArticles';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';


const FORM_TYPE_UA: Record<TaxFormType, string> = {
  VAT: 'ПДВ (ф.0110)',
  PROFIT: 'Прибуток (ф.0102)',
};


export function TaxDeclarationArticlesPage() {
  const [formType, setFormType] = useState<TaxFormType | ''>('');
  const list = useQuery({
    queryKey: ['tax-decl-articles', formType],
    queryFn: () => taxDeclarationArticles.list({
      form_type: formType || undefined,
      limit: 500,
    }),
  });
  const cols = useMemo<ColumnDef<TaxDeclarationArticle>[]>(
    () => [
      { key: 'code', header: 'Код', width: 140, sortValue: (r) => r.code ?? '', cell: (r) => r.code },
      {
        key: 'form_type', header: 'Форма', width: 180,
        sortValue: (r) => FORM_TYPE_UA[r.form_type] ?? String(r.form_type),
        cell: (r) => FORM_TYPE_UA[r.form_type] ?? String(r.form_type),
      },
      { key: 'line_number', header: 'Рядок', width: 90, sortValue: (r) => r.line_number ?? '', cell: (r) => r.line_number },
      { key: 'name', header: 'Назва', sortValue: (r) => r.name ?? '', cell: (r) => r.name },
      {
        key: 'is_active', header: 'Активна', width: 110, align: 'center',
        sortValue: (r) => (r.is_active ? 1 : 0),
        cell: (r) => (r.is_active ? '✓ так' : 'ні'),
      },
      { key: 'effective_from', header: 'Діє з', width: 130, sortValue: (r) => r.effective_from ?? '', cell: (r) => r.effective_from },
    ],
    [],
  );
  return (
    <>
      <div className="toolbar" style={{ gap: 12 }}>
        <h2 style={{ margin: 0 }}>Статті форм декларацій</h2>
        <select
          value={formType}
          onChange={(e) => setFormType(e.target.value as TaxFormType | '')}
          style={{ width: 140, flex: '0 0 auto' }}
        >
          <option value="">Усі форми</option>
          <option value="VAT">ПДВ (ф.0110)</option>
          <option value="PROFIT">Прибуток (ф.0102)</option>
        </select>
        <span style={{ marginLeft: 'auto', color: '#666' }}>
          Усього: {list.data?.total ?? 0}
        </span>
      </div>
      <DataTable<TaxDeclarationArticle>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає даних."
        initialSortKey="code"
      />
    </>
  );
}
